module.exports = __webpack_public_path__ + "img/13.f18e3e6c.svg";